import { uuid4 } from '@sentry/utils';

import handleEvent from 'utilities/handleEvent';

import styles from './styles.module.scss';

const Button = ({
    className = '',
    dataGtm = '',
    disabled,
    label,
    onClick,
    id,
    dataTestId
}) => {
    const handleClick = onClick => handleEvent(onClick);
    const classes = [
        className,
        disabled ? styles.disabled : '',
        styles.button
    ].join(' ');

    return (
        <button
            id={id}
            className={classes}
            data-click-type="button"
            data-gtm={dataGtm}
            disabled={disabled}
            data-testid={dataTestId || uuid4()}
            onClick={handleClick(onClick)}
        >
            {label}
        </button>
    );
};

export default Button;
